import { SHARED_DEALS } from '../sharedConfig';

export default {
  key: 'general1k',
  label: 'General Display Strategy - $1K Budget',
  strategySets: {
    default: {
      label: 'Standard (5 items)',
      lineItems: [
        { name: 'CPM_Broad_21+_X_DIS_Prospecting', segment: 'BROAD_21PLUS', budgetAllocation: 30 },
        { name: 'CPM_BT_Cannabis_Interest_WithSegments_DIS_Prospecting', segment: 'CANNABIS_INTEREST', budgetAllocation: 17.5 },
        { name: 'CPM_BT_CannabisDeliveryResearchers_KnownResearchers_WithSegments_DIS_Prospecting', segment: 'CANNABIS_DELIVERY', budgetAllocation: 17.5 },
        { name: 'CPM_BT_DispensaryVisitors_KnownVisitors_WithSegments_DIS_Prospecting', segment: 'DISPENSARY_VISITORS', budgetAllocation: 17.5 },
        { name: 'CPM_BT_DispensaryResearchers_KnownResearchers_WithSegments_DIS_Prospecting', segment: 'DISPENSARY_RESEARCH', budgetAllocation: 17.5 },
      ],
    },
  },
  deals: SHARED_DEALS,
};
